/**
 * 客户端识别号
 * WEB 网页端
 * */
export const clientId = {
    WEB: 'WEB'
}
